import { api, PAGE_SIZE, urlUtils } from '@igblsln/store';
const API_PATH = "/sale/sale_receipt/";
export const purchaseOrderApi = api.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
        getSourceOfFunds: build.query({
            query: () => {
                return {
                    url: urlUtils("/sale/source_of_fund/?without_pagination=1"),
                };
            },
        }),
        listReceiveSaleInvoice: build.query({
            query: ({ page, size, project, unit }) => {
                return {
                    url: urlUtils("/sale/payment/all?receivable_invoices=1", `&page=${page || 1}&page_size=${size || PAGE_SIZE}${project ? `&project_id=${project}` : ''}${unit ? `&unit_id=${unit}` : ''}`),
                };
            },
            providesTags: (result) => {
                var _a;
                return result ? [
                    ...(_a = result === null || result === void 0 ? void 0 : result.results) === null || _a === void 0 ? void 0 : _a.map(({ key }) => ({ type: "RECEIVE_SALE_INVOICE", key })),
                    { type: "RECEIVE_SALE_INVOICE", id: 'LIST' },
                ] : [{ type: "RECEIVE_SALE_INVOICE", id: 'LIST' }];
            },
        }),
        listSaleReceipt: build.query({
            query: ({ page, size, project, unit }) => {
                return {
                    url: urlUtils(API_PATH, `?page=${page || 1}&page_size=${size || PAGE_SIZE}${project ? `&project_id=${project}` : ''}${unit ? `&unit_id=${unit}` : ''}`),
                };
            },
            providesTags: (result) => {
                var _a;
                return result ? [
                    ...(_a = result === null || result === void 0 ? void 0 : result.results) === null || _a === void 0 ? void 0 : _a.map(({ key }) => ({ type: "RECEIVE_SALE_INVOICE", key })),
                    { type: "RECEIVE_SALE_INVOICE", id: 'LIST' },
                ] : [{ type: "RECEIVE_SALE_INVOICE", id: 'LIST' }];
            },
        }),
        addReceiveSaleInvoice: build.mutation({
            query: (body) => ({
                url: API_PATH,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: "RECEIVE_SALE_INVOICE", id: 'LIST' }],
        }),
        deleteSaleReceipt: build.mutation({
            query(id) {
                return {
                    url: `${API_PATH}${id}`,
                    method: 'DELETE',
                };
            },
            invalidatesTags: (payment) => [{ type: "RECEIVE_SALE_INVOICE", id: payment === null || payment === void 0 ? void 0 : payment.id }],
        }),
        getErrorProne: build.query({
            query: () => 'error-prone',
        }),
        exportSaleReceipts: build.query({
            query: ({ projectId, unitId }) => {
                const unitParam = unitId ? `&unit_id=${unitId}` : "";
                return {
                    url: urlUtils(`/sale/sale_receipt/export?project_id=${projectId}${unitParam}`),
                };
            },
        }),
    }),
});
export const { useGetSourceOfFundsQuery, useListReceiveSaleInvoiceQuery, useListSaleReceiptQuery, useAddReceiveSaleInvoiceMutation, useDeleteSaleReceiptMutation, useGetErrorProneQuery, useExportSaleReceiptsQuery, } = purchaseOrderApi;
